import React, { useEffect } from "react";
import { Button, Col, Form, Input, Row, Select } from "antd";

const FilterComponent = ({ handleSubmit, form }) => {
  const { getFieldDecorator, setFieldsValue } = form;
  const optionSelect = [
    { text: "รอดำเนินการ", value: "pending" },
    { text: "ทั้งหมด", value: "" },
    { text: "ติดต่อแล้ว", value: "completed" },
  ];
  useEffect(() => {
    setFieldsValue({ status: "pending" });
  }, []);

  return (
    <Form name="premium-contact-form" layout="horizontal">
      <Row gutter={16}>
        <Col span={11}>
          <Form.Item
            label="ค้นหา"
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 19 }}
            labelAlign="right"
            style={{ margin: "0px" }}
          >
            {getFieldDecorator("search")(
              <Input
                placeholder="ค้นหาจากรหัสสมาชิก, ชื่อ, นามสกุล หรือเบอร์โทรศัพท์"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSubmit(form);
                  }
                }}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={11}>
          <Form.Item
            label="สถานะดำเนินการ"
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 19 }}
            labelAlign="right"
            style={{ margin: "0px" }}
          >
            {getFieldDecorator("status")(
              <Select className="w-100" style={{ width: "100%" }}>
                {optionSelect.map((option, i) => (
                  <Select.Option value={option.value} key={i}>
                    {option.text}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={2} style={{ paddingtop: "8px" }}>
          <Button
            type="primary"
            style={{ width: "100%", marginTop: "3px" }}
            onClick={() => handleSubmit(form)}
          >
            ค้นหา
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default Form.create()(FilterComponent);
